import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface SettingsCardProps {
  title?: string;
  children: ReactNode;
}

export function SettingsCard({ title, children }: SettingsCardProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: (t) => `${t.shape.borderRadius}px`,
        mb: 3,
      }}
    >
      {title && (
        <Box sx={{ px: 3, py: 2, borderBottom: 1, borderBottomColor: 'divider' }}>
          <Typography
            sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary', letterSpacing: '0.01em' }}
          >
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={{ px: 3, py: 0.5 }}>{children}</Box>
    </Box>
  );
}
